export const messages = {
  en: {
    company: {
      title: 'You don\'t have a store, please complete the store information first',
      shopInfo: 'Store Information',
      notice: 'Notice',
      basicInfo: 'Basic Information',
      previous: 'Previous',
      next: 'Next',
      submit: 'Submit',
      pleaseReadNotice: 'Please read the notice and check the confirmation',
      agreeNoticeRequired: 'You must agree to the notice'
    },
    companyBase: {
      completeShopInfo: 'Complete Merchant Store',
      companyName: 'Company Name',
      companyNamePlaceholder: 'Required, please enter merchant name',
      shopType: 'Store Type',
      shopTypePlaceholder: 'Required, please select store type',
      shopName: 'Store Name',
      shopNamePlaceholder: 'Required, please fill in carefully, cannot be modified later',
      shopArea: 'Store Area',
      provincePlaceholder: 'Please select province',
      cityPlaceholder: 'Please select city',
      areaPlaceholder: 'Please select district',
      shopAddress: 'Store Address',
      shopAddressPlaceholder: 'Required, please fill in store address',
      contactPhone: 'Contact Phone',
      contactPhonePlaceholder: 'Required, please fill in contact phone, usually customer service phone'
    },
    companyReadme: {
      notice: 'Notice',
      agreeNotice: 'I agree and comply with the above information'
    }
  },
  zh: {
    company: {
      title: '您没有店铺，请先完善开店信息',
      shopInfo: '店铺信息',
      notice: '须知',
      basicInfo: '基本信息',
      previous: '上一步',
      next: '下一步',
      submit: '提交',
      pleaseReadNotice: '请阅读须知并勾选确认',
      agreeNoticeRequired: '必须同意须知条款'
    },
    companyBase: {
      completeShopInfo: '完善商家店铺',
      companyName: '公司名称',
      companyNamePlaceholder: '必填，请输入商家名称',
      shopType: '店铺类型',
      shopTypePlaceholder: '必填，请选择商铺类型',
      shopName: '店铺名称',
      shopNamePlaceholder: '必填，请认真填写，后期无法自主修改',
      shopArea: '店铺地区',
      provincePlaceholder: '请选择省',
      cityPlaceholder: '请选择城市',
      areaPlaceholder: '请选择区县',
      shopAddress: '店铺地址',
      shopAddressPlaceholder: '必填，请填写店铺地址',
      contactPhone: '联系电话',
      contactPhonePlaceholder: '必填，请填写联系电话，一般填写客服电话'
    },
    companyReadme: {
      notice: '须知',
      agreeNotice: '我同意并遵守以上信息'
    }
  }
}